import { useMemo } from 'react'

import { getConfig } from '@/shared/config/quizzes'
import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useBlocker } from '@/shared/hooks/useBlocker'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { sortByPosition } from '@/shared/lib/array/sort-by-position'
import { filterVisibleForGuilds } from '@/shared/lib/guild/visibility'
import type { BlockCondition } from '@/types/blocker'
import type { Quiz } from '@/types/quiz'

import { useGamificationDataStore } from './gamificationDataStore'

export const useQuizzesStore = () => {
  const { digitalProductId } = useDigitalProductContext()
  const config = getConfig({ digitalProductId })

  const { quizzes: quizzesRaw } = useGamificationDataStore(s =>
    s.getActiveProductData()
  )

  const { generateConditions } = useBlocker()
  const { guildIds } = useUserProgress()

  const quizzes = useMemo(() => {
    // O bundle traz os quizzes do evento inteiro; o recorte por guilda é
    // decidido aqui. A imposição de verdade é do servidor (`Ability::User`).
    const sortedQuizzes = filterVisibleForGuilds(quizzesRaw as Quiz[], guildIds)
      .slice()
      .sort(sortByPosition)

    return sortedQuizzes.map(quiz => {
      let _blockCondition: BlockCondition = {
        type: 'and',
        conditions: generateConditions(quiz)
      }

      return {
        ...quiz,
        _blockCondition
      }
    })
  }, [quizzesRaw, guildIds])

  return {
    quizzes,
    config
  }
}
